import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1983a794"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Wish Details", -1))
const _hoisted_3 = {
  key: 0,
  class: "permanent big-margin"
}
const _hoisted_4 = {
  key: 1,
  class: "permanent big-margin"
}
const _hoisted_5 = {
  key: 2,
  class: "text-reg"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Standard Wish \"")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("\" is a standard wish with no time limit. Non-event-exclusive characters and weapons are available. ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" In this wish, "),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "guaranteed"),
  /*#__PURE__*/_createTextVNode(" to win 4-star or above item at least once per 10 attempts. ")
], -1))
const _hoisted_9 = {
  key: 3,
  class: "text-reg"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Event Wish \"")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("\" is now available. During this event wish, the ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "event-exclusive", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 5-star character ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" as well as 4-star characters ")
const _hoisted_15 = {
  key: 0,
  style: {"color":"black"}
}
const _hoisted_16 = {
  key: 1,
  style: {"color":"black"}
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" will receive a ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "huge drop-rate boost", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode("! ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "red" }, " ※ Of the above characters, the event-exclusive character will not be available in the standard wish \"Wanderlust Invocation.\" ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-reg" }, " ※In most cases, the base probability of all characters and weapons is evenly distributed. If there is a boost or guarantee in effect, please refer to the corresponding rules. ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-reg" }, "〓Rules〓", -1))
const _hoisted_25 = {
  key: 4,
  class: "text-reg"
}
const _hoisted_26 = /*#__PURE__*/_createStaticVNode(" Base probability of winning 5-star item = <span class=\"red\" data-v-1983a794>0.600%</span>; base probability of winning 5-star character = <span class=\"red\" data-v-1983a794>0.300%</span>, and base probability of winning winning 5-star weapon = <span class=\"red\" data-v-1983a794>0.300%</span>; consolidated probability (incl. guarantee) of winning 5-star item = <span class=\"red\" data-v-1983a794>1.600%</span>; guaranteed to win 5-star item at least once per <span class=\"red\" data-v-1983a794>90</span> attempts. Base probability of winning 4-star item = <span class=\"red\" data-v-1983a794>5.100%</span>; base probability of winning 4-star character = <span class=\"red\" data-v-1983a794>2.550%</span>, and base probability of winning 4-star weapon = <span class=\"red\" data-v-1983a794>2.550%</span>; consolidated probability (incl. guarantee) of winning 4-star item = <span class=\"red\" data-v-1983a794>13.000%</span>; guaranteed to win 4-star or above item at least once per <span class=\"red\" data-v-1983a794>10</span> attempts; probability of winning 4-star item through the guarantee = <span class=\"red\" data-v-1983a794>99.400%</span>, and probability of winning 5-star item through the guarantee = <span class=\"red\" data-v-1983a794>0.600%</span>. ", 25)
const _hoisted_51 = [
  _hoisted_26
]
const _hoisted_52 = {
  key: 5,
  class: "text-reg"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5-Star Items", -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" For Event Wish \"")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("\": Base probability of winning 5-star character = ")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "0.600%", -1))
const _hoisted_57 = /*#__PURE__*/_createTextVNode("; consolidated probability (incl. guarantee) = ")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "1.600%", -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode("; guaranteed to win 5-star character at least once per ")
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "90", -1))
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" attempts. ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" The first time you win a 5-star item in this event wish, there is a ")
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "50.000%", -1))
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" chance it will be the promotional character ")
const _hoisted_65 = /*#__PURE__*/_createTextVNode(". If the first 5-star character you win in this event wish is not the promotional character, then the next 5-star character you win is ")
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "guaranteed", -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" to be the promotional character. ")
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4-Star Items", -1))
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" For Event Wish \"")
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("&quot;: Base probability of winning 4-star item = <span class=\"red\" data-v-1983a794>5.100%</span>; base probability of winning 4-star character = <span class=\"red\" data-v-1983a794>2.550%</span>, and base probability of winning 4-star weapon = <span class=\"red\" data-v-1983a794>2.500%</span>; consolidated probability (incl. guarantee) of winning 4-star item = <span class=\"red\" data-v-1983a794>13.000%</span>; guaranteed to win 4-star or above item at least once per <span class=\"red\" data-v-1983a794>10</span> attempts; probability of winning 4-star item through the guarantee = <span class=\"red\" data-v-1983a794>99.400%</span>, and probability of winning 5-star item through the guarantee = <span class=\"red\" data-v-1983a794>0.600%</span>. ", 15)
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" The first time you win a 4-star item in this event wish, there is a ")
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "50.000%", -1))
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" chance it will be one of the featured characters ")
const _hoisted_88 = {
  key: 0,
  style: {"color":"black"}
}
const _hoisted_89 = {
  key: 1,
  style: {"color":"black"}
}
const _hoisted_90 = /*#__PURE__*/_createTextVNode(". If the first 4-star item you win in this event wish is not one of the featured characters, then the next 4-star item you win is ")
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red" }, "guaranteed", -1))
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" to be a featured character. ")
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_94 = { class: "text-reg" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("5-star weapons won in this wish come with ")
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gold" }, "Masterless Starglitter", -1))
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" ×10; ")
const _hoisted_99 = [
  _hoisted_96,
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = /*#__PURE__*/_createTextVNode("4-star weapons ")
const _hoisted_101 = { key: 1 }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("come with ")
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gold" }, "Masterless Starglitter", -1))
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" ×2; 3-star weapons ")
const _hoisted_105 = { key: 2 }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("come with ")
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "purple" }, "Masterless Stardust", -1))
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" ×15. ")
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_110 = { class: "text-reg" }
const _hoisted_111 = /*#__PURE__*/_createStaticVNode("<p data-v-1983a794>〓Duplicate Characters〓</p><p data-v-1983a794> On obtaining a 5-star character that you already own (whether obtained in a wish, redeemed at the shop, or awarded by the game): The 2nd – 7th time you obtain the character, it will be converted into <span class=\"purple\" data-v-1983a794> that character&#39;s Stella Fortuna</span> ×1 and <span class=\"gold\" data-v-1983a794>Masterless Starglitter</span> ×10; from the 8th time onwards it will be converted into <span class=\"gold\" data-v-1983a794>Masterless Starglitter</span> ×25. </p><p data-v-1983a794> On obtaining a 4-star character that you already own (whether obtained in a wish, redeemed at the shop, or awarded by the game): The 2nd – 7th time you obtain the character, it will be converted into <span class=\"purple\" data-v-1983a794> that character&#39;s Stella Fortuna</span> ×1 and <span class=\"gold\" data-v-1983a794>Masterless Starglitter</span> ×2; from the 8th time onwards it will be converted into <span class=\"gold\" data-v-1983a794>Masterless Starglitter</span> ×5. </p>", 3)
const _hoisted_114 = { key: 0 }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ※ This is a character event wish. The wish guarantee count for \"Character Event Wish\" and \"Character Event Wish-2\" is shared, and is accumulated between both \"Character Event Wish\" and \"Character Event Wish-2\". The wish guarantee count is independent of the guarantee counts of other types of wishes. ", -1))
const _hoisted_117 = [
  _hoisted_115,
  _hoisted_116
]

import { ElementDatabase, ItemDatabase } from "@/state/Gacha";
import BannerStylisedText from "./BannerStylisedText.vue";
import { Banner, Item } from "@/types";


export default /*#__PURE__*/_defineComponent({
  props: {
    banner: null
  },
  setup(__props: any) {

const props = __props as { banner: Banner }


const isFeaturedBanner = props.banner.featuredDrops.length > 0;
const featured5Star = props.banner.featuredDrops
  .filter((item) => ItemDatabase[item].rarity === 5)
  .map((item) => ItemDatabase[item]);
const featured4Stars = props.banner.featuredDrops
  .filter((item) => ItemDatabase[item].rarity === 4)
  .map((item) => ItemDatabase[item]);

const getCharacterElementStyle = (character: Item) => {
  return {
    color: ElementDatabase[character.element]?.color,
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!isFeaturedBanner)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Permanent"))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "Limited-Time Event")),
    (!isFeaturedBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _hoisted_6,
            _createVNode(BannerStylisedText, { banner: __props.banner }, null, 8, ["banner"]),
            _hoisted_7
          ]),
          _hoisted_8
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", null, [
            _hoisted_10,
            _createVNode(BannerStylisedText, { banner: __props.banner }, null, 8, ["banner"]),
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("span", {
              style: _normalizeStyle(getCharacterElementStyle(_unref(featured5Star)[0]))
            }, _toDisplayString(_unref(featured5Star)[0].description
              ? `"${_unref(featured5Star)[0].description}"`
              : null) + " " + _toDisplayString(_unref(featured5Star)[0].name) + " (" + _toDisplayString(_unref(featured5Star)[0].element) + ") ", 5),
            _hoisted_14,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featured4Stars), (char, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                style: _normalizeStyle(getCharacterElementStyle(char))
              }, [
                (index === _unref(featured4Stars).length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "and "))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(char.description ? `"${char.description}"` : null) + " " + _toDisplayString(char.name) + " (" + _toDisplayString(char.element) + ")", 1),
                (index !== _unref(featured4Stars).length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, ", "))
                  : _createCommentVNode("", true)
              ], 4))
            }), 128)),
            _hoisted_17,
            _hoisted_18,
            _hoisted_19
          ]),
          _hoisted_20
        ])),
    _hoisted_21,
    _hoisted_22,
    _hoisted_23,
    _hoisted_24,
    (!isFeaturedBanner)
      ? (_openBlock(), _createElementBlock("p", _hoisted_25, _hoisted_51))
      : (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("p", null, [
            _hoisted_54,
            _createVNode(BannerStylisedText, { banner: __props.banner }, null, 8, ["banner"]),
            _hoisted_55,
            _hoisted_56,
            _hoisted_57,
            _hoisted_58,
            _hoisted_59,
            _hoisted_60,
            _hoisted_61
          ]),
          _createElementVNode("p", null, [
            _hoisted_62,
            _hoisted_63,
            _hoisted_64,
            _createElementVNode("span", {
              style: _normalizeStyle(getCharacterElementStyle(_unref(featured5Star)[0]))
            }, _toDisplayString(_unref(featured5Star)[0].description
              ? `"${_unref(featured5Star)[0].description}"`
              : null) + " " + _toDisplayString(_unref(featured5Star)[0].name) + " (" + _toDisplayString(_unref(featured5Star)[0].element) + ")", 5),
            _hoisted_65,
            _hoisted_66,
            _hoisted_67
          ]),
          _hoisted_68,
          _createElementVNode("p", null, [
            _hoisted_69,
            _createVNode(BannerStylisedText, { banner: __props.banner }, null, 8, ["banner"]),
            _hoisted_70
          ]),
          _createElementVNode("p", null, [
            _hoisted_85,
            _hoisted_86,
            _hoisted_87,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featured4Stars), (char, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                style: _normalizeStyle(getCharacterElementStyle(char))
              }, [
                (index === _unref(featured4Stars).length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, "and "))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(char.description ? `"${char.description}"` : null) + " " + _toDisplayString(char.name) + " (" + _toDisplayString(char.element) + ")", 1),
                (index !== _unref(featured4Stars).length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_89, ", "))
                  : _createCommentVNode("", true)
              ], 4))
            }), 128)),
            _hoisted_90,
            _hoisted_91,
            _hoisted_92
          ]),
          _hoisted_93
        ])),
    _createElementVNode("p", _hoisted_94, [
      (!isFeaturedBanner)
        ? (_openBlock(), _createElementBlock("span", _hoisted_95, _hoisted_99))
        : _createCommentVNode("", true),
      _hoisted_100,
      isFeaturedBanner
        ? (_openBlock(), _createElementBlock("span", _hoisted_101, "won in this wish "))
        : _createCommentVNode("", true),
      _hoisted_102,
      _hoisted_103,
      _hoisted_104,
      isFeaturedBanner
        ? (_openBlock(), _createElementBlock("span", _hoisted_105, "won in this wish "))
        : _createCommentVNode("", true),
      _hoisted_106,
      _hoisted_107,
      _hoisted_108
    ]),
    _hoisted_109,
    _createElementVNode("div", _hoisted_110, [
      _hoisted_111,
      isFeaturedBanner
        ? (_openBlock(), _createElementBlock("div", _hoisted_114, _hoisted_117))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})